import type { InvoiceListParams } from "../types/invoice";
export { toQueryString } from "../../../../helpers/queryString";

export const INVOICE_BASE_URL = "/fulfilment/accounts-payable/api/v2/invoice";

export const invoiceKeys = {
  all: ["v2-invoices"] as const,
  lists: () => [...invoiceKeys.all, "list"] as const,
  list: (params: InvoiceListParams) => [...invoiceKeys.lists(), params] as const,
  /**
   * No-arg form is the prefix used by every `invalidateQueries(invoiceKeys.summary())`
   * call site. It must NOT carry a trailing `undefined`: TanStack's partial key match
   * compares every index present in the filter key, and `undefined` never matches a
   * params object, so a filtered summary query would silently stop being invalidated.
   */
  summary: (params?: Record<string, unknown>) =>
    params === undefined
      ? ([...invoiceKeys.all, "summary"] as const)
      : ([...invoiceKeys.all, "summary", params] as const),
  details: () => [...invoiceKeys.all, "detail"] as const,
  detail: (id: number) => [...invoiceKeys.details(), id] as const,
  validation: (id: number) => [...invoiceKeys.all, "validation", id] as const,
  grn: (id: number) => [...invoiceKeys.all, "grn", id] as const,
  audit: (id: number) => [...invoiceKeys.all, "audit", id] as const,
  validationLogs: (id: number) => [...invoiceKeys.all, "validation-logs", id] as const,
  exceptions: () => [...invoiceKeys.all, "exceptions"] as const,
  exceptionList: (params: Record<string, unknown>) => [...invoiceKeys.exceptions(), params] as const,
  batchStatus: (batchId: string) => [...invoiceKeys.all, "batch-status", batchId] as const,
  attachments: (id: number) => [...invoiceKeys.all, "attachments", id] as const,
  poDetails: (poCode: string) => [...invoiceKeys.all, "po-details", poCode] as const,
  v1Detail: (id: number) => [...invoiceKeys.all, "v1-detail", id] as const,
  grnAvailable: (poCode: string) => [...invoiceKeys.all, "grn-available", poCode] as const,
};
